import styled from '@emotion/styled';
import { SPACING } from '@zola/zola-ui/src/styles/emotion';
import { mapFullFontViewToSerializedStyles, FullComponentFontView } from '../../../util/mappers';

const NAV_ITEM_PADDING_BOTTOM = 8;
const NAV_ITEM_BORDER_WIDTH = 2;

const getLinkContainerStyles = () => {
  return `
margin: 0 12px;
padding-bottom: ${NAV_ITEM_PADDING_BOTTOM}px;
border-bottom: ${NAV_ITEM_BORDER_WIDTH}px solid transparent;
`;
};

export const NavItem = styled.a<{ linkStyles: FullComponentFontView; active: boolean }>`
  ${getLinkContainerStyles()}
  ${({ linkStyles }) => mapFullFontViewToSerializedStyles(linkStyles)}
  ${({ linkStyles, active }) => `
    &:hover,
    &:focus {
      text-decoration: none;
      color: #${linkStyles.color};
      border-bottom: ${NAV_ITEM_BORDER_WIDTH}px solid #${linkStyles.color};
    }

    ${
      active &&
      `
      text-decoration: none;
      color: #${linkStyles.color};
      border-bottom: ${NAV_ITEM_BORDER_WIDTH}px solid #${linkStyles.color};
    `
    }
  `}
`;

export const NextLinkNavItem = styled.div<{ linkStyles: FullComponentFontView; active: boolean }>`
  ${getLinkContainerStyles()}
  a {
    ${({ linkStyles }) => mapFullFontViewToSerializedStyles(linkStyles)}
    &:hover, &:focus {
      text-decoration: none;
      color: ${({ linkStyles }) => ` #${linkStyles.color}`};
    }
  }
  ${({ linkStyles, active }) => `
    &:hover,
    &:focus {
      border-bottom: ${NAV_ITEM_BORDER_WIDTH}px solid #${linkStyles.color};
    }
    ${
      active &&
      `
      text-decoration: none;
      color: #${linkStyles.color};
      border-bottom: ${NAV_ITEM_BORDER_WIDTH}px solid #${linkStyles.color};
    `
    }
  `}
`;

export const NavLinkContainer = styled.ul`
  display: flex;
  justify-content: safe center;
  margin: 0;
  overflow-x: hidden; // FOR NOW BEFORE DOING MOBILE NAV
  padding: 0;
  text-align: center;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const NavContainer = styled.div<{
  inPreview?: boolean;
}>`
  position: ${({ inPreview }) => (inPreview ? 'relative' : 'sticky')};
  top: 0;
  padding-top: ${SPACING.MD};
  padding-bottom: ${SPACING.SM};
`;
